import React from 'react';
import { BellIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { sampleNotifications } from '../data/sampleData';
interface NotificationsPageProps {
  navigateTo: (page: string) => void;
  setSelectedPlotId: (id: string) => void;
}
export function NotificationsPage({
  navigateTo,
  setSelectedPlotId
}: NotificationsPageProps) {
  const {
    language,
    t
  } = useLanguage();
  const inlineNotifications = [{
    id: 4,
    title: 'Mutation Approved',
    titleBn: 'নামজারি অনুমোদিত',
    message: 'Mutation for PLOT-001 has been approved.',
    messageBn: 'PLOT-001 এর নামজারি অনুমোদিত হয়েছে।',
    date: '2026-03-05',
    read: false,
    plotId: 'PLOT-001'
  }, {
    id: 5,
    title: 'New Service Available',
    titleBn: 'নতুন সেবা চালু',
    message: 'Digital CLO verification is now available online.',
    messageBn: 'ডিজিটাল সিএলও যাচাই এখন অনলাইনে পাওয়া যাচ্ছে।',
    date: '2026-02-28',
    read: true,
    plotId: null
  }, {
    id: 6,
    title: 'Payment Received',
    titleBn: 'পেমেন্ট গৃহীত',
    message: 'Tax payment of ৳450 for PLOT-001 received.',
    messageBn: 'PLOT-001 এর ৳৪৫০ কর পেমেন্ট গৃহীত হয়েছে।',
    date: '2026-02-20',
    read: true,
    plotId: 'PLOT-001'
  }];
  const allNotifications = [...sampleNotifications, ...inlineNotifications].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const handleViewPlot = (plotId: string) => {
    setSelectedPlotId(plotId);
    navigateTo('plotDetails');
  };
  return <div className="max-w-4xl mx-auto space-y-6 pb-10" data-id="element-1132">
      <div className="flex items-center justify-between bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-1133">
        <div className="flex items-center space-x-3" data-id="element-1134">
          <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-1135">
            <BellIcon className="w-6 h-6 text-blue-600" data-id="element-1136" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1137">
            {t('navNotifications') || 'Notifications'}
          </h1>
        </div>
        <button className="text-sm font-medium text-[#006A4E] hover:underline" data-id="element-1138">
          {language === 'bn' ? 'সব পঠিত হিসেবে চিহ্নিত করুন' : 'Mark all as read'}
        </button>
      </div>

      <div className="space-y-4" data-id="element-1139">
        {allNotifications.map(notification => <div key={notification.id} className={`bg-white p-5 rounded-xl border transition-all ${!notification.read ? 'border-blue-200 shadow-md bg-blue-50/30' : 'border-gray-200 shadow-sm hover:shadow-md'}`} data-id="element-1140">
            <div className="flex items-start justify-between" data-id="element-1141">
              <div className="flex items-start space-x-4" data-id="element-1142">
                <div className="mt-1" data-id="element-1143">
                  {!notification.read ? <div className="w-3 h-3 bg-blue-600 rounded-full shadow-sm" data-id="element-1144"></div> : <CheckCircleIcon className="w-5 h-5 text-gray-400" data-id="element-1145" />}
                </div>
                <div data-id="element-1146">
                  <h3 className={`text-lg font-bold ${!notification.read ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-1147">
                    {language === 'bn' ? notification.titleBn : notification.title}
                  </h3>
                  <p className={`mt-1 ${!notification.read ? 'text-gray-800 font-medium' : 'text-gray-600'}`} data-id="element-1148">
                    {language === 'bn' ? notification.messageBn : notification.message}
                  </p>
                  <p className="text-xs text-gray-500 mt-2 font-medium" data-id="element-1149">
                    {new Date(notification.date).toLocaleDateString(language === 'bn' ? 'bn-BD' : 'en-GB', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
                  </p>
                </div>
              </div>

              {notification.plotId && <button onClick={() => handleViewPlot(notification.plotId!)} className="flex items-center px-4 py-2 bg-gray-100 text-[#006A4E] rounded-lg text-sm font-bold hover:bg-green-50 hover:text-[#004D3A] transition-colors border border-gray-200 hover:border-green-200 whitespace-nowrap ml-4" data-id="element-1150">
                  <MapPinIcon className="w-4 h-4 mr-2" data-id="element-1151" />
                  {language === 'bn' ? 'প্লট দেখুন' : 'View Plot'}
                </button>}
            </div>
          </div>)}
      </div>
    </div>;
}